import React, { createContext, useContext } from "react"

import { useAppContext } from "@contexts/app_context"

const AiEvalsPageContext = createContext({
  translate: (key: string) => key
})

export function AiEvalsPageContextProvider(props: {
  children: JSX.Element | JSX.Element[]
}) {
  const { translate } = useAppContext()
  return (
    <AiEvalsPageContext.Provider value={{ translate }}>
      {props.children}
    </AiEvalsPageContext.Provider>
  )
}

export function useAiEvalsPageContext() {
  return useContext(AiEvalsPageContext)
}
